import React from "react";
import { Typography } from "@mui/material";
import { CommonGrid2 } from "./StyledComponents";
import NoDataFoundIco from "../../assets/icons/NoDataFound";
const REDS = [
  "#FF0000",
  "#E53935",
  "#EF5350",
  "#FF1744",
  "#D32F2F",
  "#FF5252",
  "#C62828",
  "#FF6B6B",
  "#B71C1C",
  "#FF4444",
  "#FF6666",
  "#CC0000",
  "#FF3333",
  "#E00000",
  "#FF2222",
  "#F44336",
  "#FF8A80",
  "#FF5050",
  "#DD2222",
  "#FF0022",
];

export const spawnBubbles = (container, W, H, count, wave) => {
  for (let i = 0; i < count; i++) {
    const size = 2 + Math.random() * 6;
    const startX = Math.random() * W;
    const startY = Math.random() * H;
    const color = REDS[Math.floor(Math.random() * REDS.length)];
    const op = 0.55 + Math.random() * 0.45;

    const b = document.createElement("div");
    b.style.cssText = `
        position:absolute;
        border-radius:50%;
        pointer-events:none;
        will-change:transform,opacity;
        width:${size}px;
        height:${size}px;
        left:${startX}px;
        top:${startY}px;
        background:${color};
        opacity:${op};
        box-shadow:0 0 ${size}px ${color}99, 0 0 ${size * 2}px ${color}44;
      `;
    container.appendChild(b);

    const angle = Math.random() * Math.PI * 2;
    const dist = 40 + Math.random() * 130;
    const dx = Math.cos(angle) * dist;
    const dy = Math.sin(angle) * dist - Math.random() * 50;
    const baseDelay = wave * 80 + Math.random() * 100;
    const dur = 450 + Math.random() * 350;

    b.animate(
      [
        { transform: "translate(0,0) scale(1)", opacity: op },
        {
          transform: `translate(${dx * 0.35}px,${dy * 0.35}px) scale(${
            1 + Math.random() * 0.6
          })`,
          opacity: op + 0.1,
          offset: 0.25,
        },
        {
          transform: `translate(${dx * 0.7}px,${dy * 0.7}px) scale(${
            0.9 + Math.random() * 0.4
          })`,
          opacity: op * 0.6,
          offset: 0.65,
        },
        { transform: `translate(${dx}px,${dy}px) scale(0)`, opacity: 0 },
      ],
      {
        duration: dur,
        delay: baseDelay,
        easing: "cubic-bezier(0.15,0.85,0.35,1)",
        fill: "forwards",
      }
    );
  }
};

export const statusOptions = {
  Active: { color: "#17B26A", id: "Active", border: "1px solid #17B26A" },
  Unavailable: {
    color: "#9E77ED",
    id: "Unavailable",
    border: "1px solid #9E77ED",
  },
  Inactive: { color: "#667085", id: "Inactive", border: "1px solid #667085" },
  "Do Not Hire": {
    color: "#F04438",
    id: "Do Not Hire",
    border: "1px solid #F04438",
  },
};
export const NoDataFound = ({ message, padding }) => {
  return (
    <CommonGrid2
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      padding={padding}
    >
      <CommonGrid2
        flexDirection={"column"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <NoDataFoundIco />
        <Typography color="#8C9BAB" fontWeight={600}>
          {message}
        </Typography>
      </CommonGrid2>
    </CommonGrid2>
  );
};
